import * as React from 'react';
import { cn } from '../../lib/utils';

const Switch = React.forwardRef(
  ({ className, enabled, onChange, disabled = false, ...props }, ref) => {
    return (
      <button
        type='button'
        role='switch'
        aria-checked={enabled}
        data-state={enabled ? 'checked' : 'unchecked'}
        disabled={disabled}
        ref={ref}
        onClick={() => onChange?.(!enabled)}
        className={cn(
          'peer relative inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50',
          enabled ? 'bg-green-500' : 'bg-gray-200',
          className
        )}
        {...props}
      >
        {' '}
        <span
          className={cn(
            'pointer-events-none absolute top-[1px] left-[1px] inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition-transform duration-200 ease-in-out',
            enabled ? 'translate-x-5' : 'translate-x-0'
          )}
        />
      </button>
    );
  }
);
Switch.displayName = 'Switch';

export { Switch };
